import { getEnvVariable } from "../../../modules/environmentalList"
//import Attachmenthistory from './Attachmenthistorygrid';
const AttachmentEdit = {
    "type": "popup",
    "key": "AttachmentEdit",
    "name": "AttachmentEdit",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'editOpen'
    },
    sharedValues: ['open'],
    container: {
        values: { editInfo: null, edit: false, createduplicate: false, fullscreen: false, back: false, allgriddata: null, navigation: null },
        mapValues: {
            header: [
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'allgriddata', name: 'allgriddata' },
                { key: 'navigation', name: 'navigation' },
                { key: 'editInfo', name: 'editInfo' },
            ],
            ViewAttachment: [
                { key: 'editInfo', name: 'editInfo' },
                { key: 'allgriddata', name: 'allgriddata' },
                { key: 'save', name: 'save' },
                { key: 'saveduplicate', name: 'saveduplicate' },
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'back', name: 'back' },
                { key: 'navigation', name: 'navigation' },]
        },
        //  sharedValues: ['save', 'edit'],
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: 'm-1',
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12 ',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },
            {
                order: 1,
                type: 'div',
                className: 'row application-border m-1',
                components: [{
                    name: 'ViewAttachment',
                    type: 'div',
                    className: 'col-12',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                },
                    // {
                    //     name: 'InsuranceContainer'
                    // }
                ],
            },
            ]
        },
        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'View/Edit Insurance',

                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "View/Edit Attachments", "materialicon": "request_page", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                    },
                    {
                        type: 'icon',
                        icon: 'edit',
                        name: 'edit',
                        hideon: 'createduplicate',
                        hideanother: 'edit',
                        hidevalue: true,
                        title: 'Edit '
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'save',
                        hideon: 'edit',
                        hidevalue: false,
                        title: 'Save '
                    },

                    {
                        type: 'icon',
                        icon: 'previtem',
                        name: 'previtem',
                        hideon: 'previtem',
                        hidevalue: false,
                        title: 'Previous Item'
                    },
                    {
                        type: 'icon',
                        icon: 'nextitem',
                        name: 'nextitem',
                        hideon: 'nextitem',
                        hidevalue: false,
                        title: 'Next Item'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hideon: 'exitfullscreen',
                        hidevalue: false
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false
                    }
                ],
            },
            ViewAttachment: {
                "type": "form",
                initRun: true,
                //className: 'row application-border mx-2',
                "key": "ViewAttachment",
                "name": "ViewAttachment",
                noParams: true,
                layout: {

                    group: [
                        // {
                        //     order: 0,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [{
                        //         name: 'MId',
                        //         type: 'div',
                        //         className: 'col-10 ml-3 mt-2',
                        //         sub: {
                        //             type: 'div',
                        //             className: 'col-10  ml-3 mt-2',
                        //         }
                        //     },
                        //     ],
                        // },
                        {
                            order: 1,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'FileName',
                                type: 'div',
                                className: 'col-10 ml-3 mt-2',
                                sub: {
                                    type: 'div',
                                    className: 'col-10 ml-3 mt-2',
                                }
                            }],

                        },
                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'Notes',
                                    type: 'div',
                                    className: 'col-10 ',
                                    sub: {
                                        type: 'div',
                                        className: 'col-10 ',
                                    }
                                },
                            ]
                        },
                        // {
                        //     order: 3,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [
                        //         {
                        //             name: 'PaperDocument',
                        //             type: 'div',
                        //             className: 'col-5 ',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-5 ',
                        //             }
                        //         },

                        //     ]
                        // },
                        // {
                        //     order: 4,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [
                        //         {
                        //             name: 'PhaseType',
                        //             type: 'div',
                        //             className: 'col-10 ',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-10 ',
                        //             }
                        //         },
                        //     ]
                        // },


                        {
                            order: 4,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'FileDetails',
                                    type: 'div',
                                    className: 'col-12',
                                    sub: {
                                        type: 'div',
                                        className: 'col-12'
                                    }
                                },
                            ]
                        },
                        // {
                        //     order: 5,
                        //     type: 'div',
                        //     className: 'row',
                        //     components: [
                        //         {
                        //             name: 'UploadDocuments',
                        //             type: 'div',
                        //             className: 'col-12',
                        //             sub: {
                        //                 type: 'div',
                        //                 className: 'col-12'
                        //             }
                        //         },
                        //     ]
                        // },
                    ]




                },
                aliases: {
                    save: 'save',
                    'allgriddata': 'allgriddata',
                    'navigation': 'navigation'
                },
                sharedValues: ['save', 'editInfo', 'addOpen', 'editKey', 'allgriddata', 'navigation', 'edit'],
                validationMapKeys: [],
                values: {
                    FileName: '',
                    Notes: '',
                    MId: '',
                    //PaperDocument: '',
                    Id: '',
                    //  parentId: '',
                    FileDetails: [],
                    UploadDocuments: [],
                },
                removeValues: [
                    'editInfo', 'allgriddata', 'edit', 'navigation'
                ],



                "components": {
                    MId: {
                        "type": "label",
                        "key": "MId",
                        "label": "Company ID",
                        "name": "MId",
                    },
                    FileName: {
                        "type": "label",
                        changefieldto: "textfield",
                        "key": "FileName",
                        "label": "File Name",
                        "name": "FileName",
                        required: true,
                    },
                    Notes: {
                        "type": "label",
                        changefieldto: "textfield",
                        "key": "Notes",
                        "label": "Notes",
                        name: "Notes",
                        multiline: true,
                        rowsMax: 2,
                        //disabled: getEnvVariable("AccessPortal") == "E" ? true : false
                    },
                    // PaperDocument: {
                    //     "type": "label",
                    //     changefieldto: "checkbox",
                    //     "key": "PaperDocument",
                    //     "label": "Paper Document",
                    //     name: "PaperDocument",
                    //     extraProps: {
                    //         transformProps: {
                    //             N: false,
                    //             Y: true,
                    //             'true': 'Y',
                    //             'false': 'N'
                    //         },
                    //     }


                    // },


                    FileDetails: {
                        "type": "upload",
                        "key": "FileDetails",
                        "label": "Upload Documents",
                        name: "FileDetails",
                        changefieldto: "upload",
                        // edit: true,
                        IsFilenet: true,
                        customField: true,
                        ismultiple: true,
                        ischildAttachments: false
                        //callRequest: true,
                        // extraProps: {
                        //     color: 'primary',
                        //     variant: "contained",
                        // },
                    },
                    // UploadDocuments: {
                    //     "type": "upload",
                    //     "key": "UploadDocuments",
                    //     //"label": "Upload Documents",
                    //     "name": "UploadDocuments",
                    //     edit: true,
                    //     IsFilenet: true,
                    //     customField: true,
                    //     ismultiple: true,
                    //    // ischildAttachments: true
                    //     //callRequest: true,
                    //     // extraProps: {
                    //     //     color: 'primary',
                    //     //     variant: "contained",
                    //     // },
                    // },


                },
                componentDIdMountValues: ['editInfo'],
                mapActionsToEffects: {
                    GLOBAL: {
                        rules: [{
                            run:
                            {
                                valid: [
                                    {
                                        type: 'prop',
                                        name: 'MId',
                                        hasValue: true,
                                        valueType: 'C',
                                        value: '{{Id}}',
                                        isVisible: false
                                    },
                                ]
                            }
                        }]
                    },
                    'onLoad': {
                        'init': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'validations',
                                            "read": [
                                                {
                                                    "url": getEnvVariable('Sidebar') + `/api/ProjectMessages/RulesByName?name=modulemaster.Attachments`,
                                                    type: 'get'
                                                }
                                            ],
                                            transformProps: {
                                                removesubfieldname: getEnvVariable('ModuleKey') + 'MODULEMASTER.AttachmentS_'
                                            }
                                        },
                                        {
                                            type: 'initial',
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/CompanyFiles/{MId}/file/{Id}`,
                                                    key: 'save',
                                                    "matchProps": [
                                                        {
                                                            name: "Id",
                                                            key: "MId",
                                                        },
                                                        {
                                                            name: "navigation.Id",
                                                            key: "Id",
                                                        }
                                                    ],
                                                    type: 'get',
                                                }
                                            ]
                                        },
                                        // {
                                        //     type: 'businessrules',
                                        //     "read": [
                                        //         {
                                        //             url: getEnvVariable('Sidebar') + `/api/BusinessRules/Grid/modulemaster.Attachments`,
                                        //             type: 'get',
                                        //         }
                                        //     ],
                                        // },
                                        // {
                                        //     type: 'prop',
                                        //     name: 'parentId',
                                        //     hasValue: true,
                                        //     valueType: 'C',
                                        //     value: '{{Id}}',
                                        //     isVisible: false
                                        // },
                                    ]
                                }
                            }]
                        }
                    },
                    'onChange': {
                        'navigation': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'prop',
                                            name: 'MId',
                                            hasValue: true,
                                            valueType: 'C',
                                            value: '{{Id}}',
                                            // isVisible: false
                                        },
                                        // {
                                        //     type: 'initial', 
                                        //     "read": [
                                        //         {
                                        //             url: getEnvVariable('Admin') + `/api/CompanyFiles/{MId}/file/{Id}`,
                                        //             key: 'save',
                                        //             "matchProps": [
                                        //                 {
                                        //                     name: "MId",
                                        //                     key: "MId",
                                        //                 },
                                        //                 {
                                        //                     name: "navigation.Id",
                                        //                     key: "Id",
                                        //                 }
                                        //             ],
                                        //             type: 'get',
                                        //         }
                                        //     ]
                                        // }, 
                                    ]
                                }
                            }]
                        },
                        'edit': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'edit',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'exitfullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'exitfullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'fullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'fullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'createduplicate': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'createduplicate',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    },
                    'afterSave': {
                        'save': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/CompanyFiles/{MId}/FileUploadFiles`,
                                                        type: 'post',
                                                        message: 'Updated Sucessfully',
                                                        "matchProps": [{
                                                            name: "MId",
                                                            key: "MId",
                                                        }],
                                                    }
                                                ],
                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    },

                }

            },

        },

    }
}

export default AttachmentEdit
